// Invite redirect persistence (#17).
//
// A logged-out invitee accepting a team invite must round-trip through
// signup → email verification → sign-in before they can accept. The target
// path (/accept-invite?token=...) is stashed in localStorage so it survives
// that multi-step hop, then consumed on the eventual successful sign-in.
//
// Mirrors v1's mechanism. The key is `synvya_*` so logout's sweep clears it.

const LS_INVITE_REDIRECT = 'synvya_invite_redirect'

/** Persist the invite path so it survives the signup/verify/sign-in round-trip. */
export function storeInviteRedirect(path: string): void {
  try {
    localStorage.setItem(LS_INVITE_REDIRECT, path)
  } catch {
    // localStorage unavailable — non-fatal.
  }
}

/** Read and clear a stored invite redirect, or null if none. */
export function consumeInviteRedirect(): string | null {
  try {
    const value = localStorage.getItem(LS_INVITE_REDIRECT)
    if (value) localStorage.removeItem(LS_INVITE_REDIRECT)
    return value
  } catch {
    return null
  }
}

/** True when a path is a valid accept-invite target (guards open redirects). */
export function isInviteRedirect(path: string | null | undefined): path is string {
  return typeof path === 'string' && path.startsWith('/accept-invite')
}
